import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    _id: '',
    acerca_de: {
        description: null,
        vision: null,
        mision: null
    },
    servicios: [],
    sliders: [],
    paginas: [
        {
            title_page: "Acerca de",
            slug_page: "acercade"
        },
        {
            title_page: "Servicios",
            slug_page: "servicios"
        },
        {
            title_page: "Sliders",
            slug_page: "sliders"
        }
    ],
    general: {
        email: '',
        razon_social: '',
        alias: '',
        nit: '',
        telefono: '',
        ciudad_id: '',
        ciudad_name: '',
        direccion: ''
    },
    redes_sociales: {
        facebook: '',
        whatsapp: '',
        instagram: '',
        twitter: ''
    },
    seo_tab: {
        meta_desc: null,
        keywords: null,
        ga_code: null
    },
    sedes: [],
    sede: {
        nombre: '',
        direccion: '',
        telefono: '',
        ubicacion_id: '',
        ubicacion_name: '',
        edit: false
    },
    inversionistas: [],
    inversionista: {
        _id: '',
        nombre: '',
        apellido: '',
        email: '',
        direccion: '',
        telefono: '',
        whatsapp: '',
        whatsapp_checked: false,
        ubicacion_id: '',
        ubicacion_name: '',
        new_capital: 0,
        saldo: 0,
        capital: [],
        negocios: [],
        edit: false
    },
    tramitadores: [],
    tramitador: {
        _id: '',
        nombre: '',
        tipo_identificacion: '',
        numero_identificacion: '',
        telefono: '',
        email: '',
        ubicacion_id: '',
        ubicacion_name: '',
        negocios: [],
        edit: false
    },
};
const mutations = {
    updateField,
    updateEmpresas: (state, payload) => {
        state.empresas = payload;
    },
    updateEmpresa: (state, payload) => {
        if(payload.update_sede) {
            state.sedes = payload.sedes;
        }else if(payload.update_inversionista) {
            state.inversionistas = payload.inversionistas;
        }else if(payload.update_tramitador) {
            state.tramitadores = payload.tramitadores;
        }else {
            state._id = payload.empresa._id;
            state.general = payload.empresa.general;
            state.seo_tab = payload.empresa.seo_tab;
            state.redes_sociales = payload.empresa.redes_sociales;
            state.sedes = payload.sedes;
            state.inversionistas = payload.inversionistas;
            state.tramitadores = payload.tramitadores;
        }
    },
    updatePagina: (state, payload) => {
        //Paginas
        switch (payload.slug) {
            case 'acercade':
                state.acerca_de = payload.pagina;
                break;
            case 'servicios':
                state.servicios = payload.pagina;
                break;
            case 'sliders':
                state.sliders = payload.pagina;
                break;
        }
    },
    editInversionista: (state, payload) => {
        state.inversionista._id = payload._id,
        state.inversionista.nombre = payload.nombre,
        state.inversionista.apellido = payload.apellido,
        state.inversionista.direccion = payload.direccion,
        state.inversionista.telefono = payload.telefono,
        state.inversionista.whatsapp = payload.whatsapp,
        state.inversionista.whatsapp_checked = payload.whatsapp_checked,
        state.inversionista.email = payload.email,
        state.inversionista.ubicacion_id = payload.ubicacion_id,
        state.inversionista.ubicacion_name = payload.ubicacion_name,
        state.inversionista.new_capital = 0,
        state.inversionista.capital = payload.capital,
        state.inversionista.negocios = payload.negocios,
        state.inversionista.saldo = payload.saldo_total,
        state.inversionista.edit = true
    },
    editTramitador(state, payload) {
        state.tramitador._id = payload._id,
        state.tramitador.nombre = payload.nombre,
        state.tramitador.tipo_identificacion = payload.tipo_identificacion,
        state.tramitador.numero_identificacion = payload.numero_identificacion,
        state.tramitador.telefono = payload.telefono,
        state.tramitador.email = payload.email,
        state.tramitador.ubicacion_id = payload.ubicacion_id,
        state.tramitador.ubicacion_name = payload.ubicacion_name,
        state.tramitador.negocios = payload.negocios,
        state.tramitador.edit = true
    }
};

const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
